import { useNavigate } from "react-router-dom";

const useLogout = () => {
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.clear();
    navigate("/login", { replace: true });
  };

  return [handleLogout];
};

export default useLogout;
